<template>
  <el-dialog :visible="visible"  :before-close="chartBeforeClose" v-if="inDialog">
    <highcharts :options="options()"></highcharts>
  </el-dialog>
  <highcharts v-else :options="options()"></highcharts>
</template>

<script>

  export default {
    name: "grafico-column-line",
    props:{
      inDialog: {
        default : true,
        type:Boolean
      },
      visible:{
        type:Boolean
      },
      axiox:{
        required : true,
        type:Object
      },
      axioy:{
        required : true,
        type:Object
      },
      title:{
        type:String
      },
      subtitle:{
        type:String
      },
      series:{
        type:Object
      }
    },
    methods: {
      chartBeforeClose() {
        this.$emit('update:visible', false)
      },
      options() {
        return {
          title: {
            text: this.title
          },
          subtitle: {
            text: this.subtitle
          },
          xAxis: {
            categories:  this.axiox.labels,
            title: {
              text: this.axiox.title
            }
          },
          yAxis: {
            title: {
              text:  this.axioy.title
            }
          },
          plotOptions: {

            spline: {
              dataLabels: {
                enabled: true,
                format: '{y}',
                style:{
                  textOutline:   "0.5px"
                }
              },
              enableMouseTracking: false
            },
            column: {
              stacking: 'normal',
              dataLabels: {
                enabled: true,
                borderRadius: 5,
                backgroundColor: 'rgba(62, 69, 81, 0.7) ',
                borderColor: '#AAA',
                y: -6,
                style:{
                  color: "#fff",
                  textOutline:   "0px"
                }
              }
            }
          },
          series: [{
            type: 'column',
            name:  this.series.column.name,
            data:  this.series.column.data
          }, {
            type: 'spline',
            name: this.series.spline.name,
            data: this.series.spline.data
          },
          ]
        }
      }
    }

  }
</script>



// WEBPACK FOOTER //
// src/features/Dashboard/Components/Shared/GraficoColumnLine.vue